<div class="mt-header">
    <div class="position-relative overflow-hidden">
        <app-marquee></app-marquee>
    </div>
    <div class="coin-info-top">
        <div class="container">
            <div class="row d-flex coin-top-section">
                <!-- Breadcrumbs -->
                <div class="col-12 col-sm-8 col-md-6 column-coin-top">
                    <div class="breadcrumb-inner">
                        <ul class="justify-content-center justify-content-sm-start">
                            <li>
                                <a [routerLink]="['']" style="color: inherit">
                                    {{ 'COIN.HEADER.CRYPTOCURRENCIES' | translate }}
                                </a>
                                <em class="flaticon-right-chevron" aria-hidden="true"> </em>
                            </li>
                            <li>
                                <a class="active">{{ coinDetail.coin_name }}</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Trade, Convert, and Swap Pairs dropdown -->
                <div class="col-12 col-sm-4 col-md-6 text-center text-sm-start column-coin-top">
                    <div class="d-flex justify-content-center justify-content-sm-end nowrap">
                        <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
                            <!-- Swap Dropdown -->
                            <!-- <ng-container [ngTemplateOutlet]="dropdownSkeleton"></ng-container>
                            <ng-container *ngIf="!isWalletPairsLoading">
                                <div
                                    class="btn-group mb-2 mb-md-0 mx-1"
                                    role="group"
                                    *ngIf="originalPairs.swapPairs.length > 0"
                                    (click)="toggleDropdownEvent('Swap')">
                                    <button
                                        id="btnGroupDrop1"
                                        type="button"
                                        class="btn btn-xs btn-primary dropdown-toggle"
                                        style="border-radius: 8px"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        aria-label="swap">
                                        {{ 'HEADER.NAV_MENU.SWAP' | translate }}
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                        <li class="dropdown-search" *ngIf="originalPairs.swapPairs.length > 4">
                                            <input
                                                #swapInputElement
                                                class="form-control form-control-sm shadow-none"
                                                type="text"
                                                [(ngModel)]="swapSearch"
                                                placeholder="{{ 'COIN.SEARCH_SWAP_PAIR' | translate }}"
                                                (input)="filterText('Swap')" />
                                        </li>
                                        <ng-container *ngIf="filteredSwapPairs as swapResult">
                                            <ng-container
                                                [ngTemplateOutlet]="dropdownList"
                                                [ngTemplateOutletContext]="{
                                                    $implicit: { type: 'Swap', value: filteredSwapPairs }
                                                }">
                                            </ng-container>
                                        </ng-container>
                                    </ul>
                                </div>
                            </ng-container> -->

                            <!-- Convert Dropdown -->
                            <ng-container [ngTemplateOutlet]="dropdownSkeleton"></ng-container>
                            <ng-container *ngIf="!isWalletPairsLoading">
                                <div
                                    class="btn-group mb-2 mb-md-0 mx-1"
                                    role="group"
                                    *ngIf="originalPairs.convertPairs.length > 0"
                                    (click)="toggleDropdownEvent('Convert')">
                                    <button
                                        id="btnGroupDrop2"
                                        type="button"
                                        class="btn btn-xs btn-primary dropdown-toggle"
                                        style="border-radius: 8px"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        aria-label="convert">
                                        {{ 'HEADER.NAV_MENU.CONVERT' | translate }}
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="btnGroupDrop2">
                                        <li class="dropdown-search" *ngIf="originalPairs.convertPairs.length > 4">
                                            <input
                                                #convertInputElement
                                                class="form-control form-control-sm shadow-none"
                                                type="text"
                                                [(ngModel)]="convertSearch"
                                                placeholder="{{ 'COIN.SEARCH_CONVERT_PAIR' | translate }}"
                                                (input)="filterText('Convert')" />
                                        </li>
                                        <ng-container *ngIf="filteredConvertPairs as convertResult">
                                            <ng-container
                                                [ngTemplateOutlet]="dropdownList"
                                                [ngTemplateOutletContext]="{
                                                    $implicit: { type: 'Convert', value: filteredConvertPairs }
                                                }">
                                            </ng-container>
                                        </ng-container>
                                    </ul>
                                </div>
                            </ng-container>

                            <!-- Trade Dropdown -->
                            <ng-container [ngTemplateOutlet]="dropdownSkeleton"></ng-container>
                            <ng-container *ngIf="!isWalletPairsLoading">
                                <div
                                    class="btn-group mb-2 mb-md-0 mx-1"
                                    role="group"
                                    *ngIf="originalPairs.tradePairs.length > 0"
                                    (click)="toggleDropdownEvent('Trade')">
                                    <button
                                        id="btnGroupDrop3"
                                        type="button"
                                        class="btn btn-xs btn-primary dropdown-toggle"
                                        style="border-radius: 8px"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        aria-label="trade">
                                        {{ 'HEADER.NAV_MENU.TRADE' | translate }}
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="btnGroupDrop3">
                                        <li class="dropdown-search" *ngIf="originalPairs.tradePairs.length > 4">
                                            <input
                                                #tradeInputElement
                                                class="form-control form-control-sm shadow-none"
                                                type="text"
                                                [(ngModel)]="tradeSearch"
                                                placeholder="{{ 'COIN.SEARCH_TRADE_PAIR' | translate }}"
                                                (input)="filterText('Trade')" />
                                        </li>
                                        <ng-container *ngIf="filteredTradePairs as tradeResult">
                                            <ng-container
                                                [ngTemplateOutlet]="dropdownList"
                                                [ngTemplateOutletContext]="{
                                                    $implicit: { type: 'Trade', value: filteredTradePairs }
                                                }">
                                            </ng-container>
                                        </ng-container>
                                    </ul>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Coin Name, Symbol, Image, Price, Percent Change -->
            <div class="coin-name-area d-sm-flex">
                <div class="coin justify-content-center justify-content-sm-start">
                    <picture>
                        <source [srcset]="CDN_URL + 'coins/' + coinDetail.coin_symbol + '.png'" />
                        <img [src]="CDN_URL + 'coins/' + coinDetail.coin_symbol + '.png'" title="" alt="" />
                    </picture>
                    <h1>
                        {{ coinDetail.coin_name }}
                        <span class="button-span1">
                            {{ coinDetail.coin_symbol | uppercase }}
                        </span>
                    </h1>
                </div>
                <div
                    class="coin-price-section d-sm-flex text-center text-sm-start align-items-center justify-content-center justify-content-sm-start">
                    <strong> {{ coinDetail.coin_symbol | uppercase }} {{ 'GENERAL.PRICE' | translate }} </strong>
                    <p class="d-flex justify-content-center">
                        <label class="label-coin">
                            <div class="d-inline-flex">
                                {{
                                    coinDetail.price
                                        | fiatValue: usdExchangeRate
                                        | currency: currencySymbol : 'symbol' : '1.0-' + coinDetail.precision
                                }}
                            </div>
                        </label>
                        <span [ngClass]="coinDetail.is_up ? 'text-success' : 'text-danger'">
                            <em
                                [ngClass]="
                                    coinDetail.is_up ? 'flaticon-two-arrows-pointing-up' : 'flaticon-two-down-arrows'
                                "
                                style="font-size: 10px">
                            </em>
                            <span class="label-coin">
                                <span>{{ coinDetail.change ?? 0 | absValue | number: '1.2-2' }}%</span>
                            </span>
                        </span>
                    </p>
                </div>
            </div>
        </div>

        <!-- Inner Page Navbar -->
        <nav class="sticky-navbar d-none d-lg-inline-block" #navbarElement>
            <div class="container">
                <ul class="nav" id="coin-navbar" role="tablist">
                    <li class="nav-item" role="presentation" *ngIf="sectionVisibilityMap.summary.showInNav">
                        <a
                            #navLinkElement
                            role="tab"
                            class="nav-link"
                            [routerLink]="['/coins', coinCode, 'summary']"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            (click)="goToSection('summary')">
                            {{ 'COIN.HEADER.SUMMARY' | translate }}
                        </a>
                    </li>
                    <li class="nav-item" role="presentation" *ngIf="sectionVisibilityMap.finance.showInNav">
                        <a
                            #navLinkElement
                            role="tab"
                            [routerLink]="['/coins', coinCode, 'finance']"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            class="nav-link"
                            (click)="goToSection('finance')">
                            {{ 'COIN.HEADER.FINANCE_DATA' | translate }}
                        </a>
                    </li>
                    <li class="nav-item" role="presentation" *ngIf="sectionVisibilityMap.network.showInNav">
                        <a
                            #navLinkElement
                            role="tab"
                            class="nav-link"
                            [routerLink]="['/coins', coinCode, 'network']"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            (click)="goToSection('network')">
                            {{ 'COIN.HEADER.NETWORK_DATA' | translate }}
                        </a>
                    </li>
                    <li class="nav-item" role="presentation" *ngIf="sectionVisibilityMap.ownership.showInNav">
                        <a
                            #navLinkElement
                            role="tab"
                            class="nav-link"
                            [routerLink]="['/coins', coinCode, 'ownership']"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            (click)="goToSection('ownership')">
                            {{ 'COIN.HEADER.OWNERSHIP_DATA' | translate }}
                        </a>
                    </li>
                    <li class="nav-item" role="presentation" *ngIf="sectionVisibilityMap.social.showInNav">
                        <a
                            #navLinkElement
                            role="tab"
                            class="nav-link"
                            [routerLink]="['/coins', coinCode, 'social']"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            (click)="goToSection('social')">
                            {{ 'COIN.HEADER.SOCIAL_DATA' | translate }}
                        </a>
                    </li>
                    <li class="nav-item" role="presentation" *ngIf="sectionVisibilityMap.markets.showInNav">
                        <a
                            #navLinkElement
                            role="tab"
                            class="nav-link"
                            [routerLink]="['/coins', coinCode, 'markets']"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            (click)="goToSection('markets')">
                            {{ 'GENERAL.MARKETS' | translate }}
                        </a>
                    </li>
                    <li class="nav-item" role="presentation" *ngIf="sectionVisibilityMap.news.showInNav">
                        <a
                            #navLinkElement
                            role="tab"
                            class="nav-link"
                            [routerLink]="['/coins', coinCode, 'news']"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            (click)="goToSection('news')">
                            {{ 'GENERAL.NEWS' | translate }}
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    </div>

    <!-- Coin Detail Overview -->
    <app-coin-overview [coinDetail]="coinDetail" [usdExchangeRate]="usdExchangeRate" [currencySymbol]="currencySymbol">
    </app-coin-overview>

    <div class="container" #containerElement>
        <div class="row">
            <div class="col-md-4 quick-link-section">
                <div class="card border-0 h-100">
                    <h3 class="inner-title px-3 pt-3 pb-0 mb-0">
                        {{ 'GENERAL.QUICK_LINKS' | translate }}
                    </h3>
                    <div class="px-3 py-2">
                        <div class="d-flex flex-column h-100">
                            <div
                                class="card quick-link-card d-flex"
                                *ngIf="quickLinks.website.length == 1; else moreThanOneWebsite"
                                (click)="redirect(quickLinks.website[0])">
                                <div class="btn-group">
                                    <div
                                        type="button"
                                        class="d-flex align-self-center align-items-center w-100 website-single">
                                        <span class="single-coin me-2">
                                            <app-image
                                                [imgWidth]="24"
                                                [imgHeight]="24"
                                                [imgStyle]="{ 'border-radius': '35px' }"
                                                [imgSrc]="'coins/' + coinDetail.coin_symbol + '.png'"
                                                class="d-flex">
                                            </app-image>
                                        </span>
                                        <div class="website-title-url">
                                            <strong>{{ 'COIN.QUICK_LINKS.WEBSITE' | translate }}</strong>
                                            <br />
                                            <div style="font-size: 0.875rem">
                                                {{ urlDomain | truncate: 40 }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <ng-template #moreThanOneWebsite>
                                <div class="card quick-link-card">
                                    <div class="btn-group">
                                        <div
                                            type="button"
                                            class="dropdown-toggle w-100"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false">
                                            <span class="single-coin me-3">
                                                <app-image
                                                    [imgWidth]="24"
                                                    [imgHeight]="24"
                                                    [imgSrc]="'coins/' + coinDetail.coin_symbol + '.png'">
                                                </app-image>
                                            </span>
                                            {{ 'COIN.QUICK_LINKS.WEBSITE' | translate }}
                                        </div>
                                        <ul class="dropdown-menu">
                                            <li *ngFor="let website of quickLinks.website">
                                                <button
                                                    aria-label="Website dropdown"
                                                    class="dropdown-item d-flex justify-content-between"
                                                    (click)="redirect(website)">
                                                    {{ website | truncate: 40 }}
                                                    <em class="flaticon-exit-top-right exit-top-right"></em>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </ng-template>

                            <!-- Explorer dropdown -->
                            <div class="card quick-link-card" *ngIf="quickLinks.explorer.length > 0">
                                <div class="btn-group">
                                    <div
                                        type="button"
                                        class="dropdown-toggle w-100"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false">
                                        <span class="quick-links-icon me-2">
                                            <app-image
                                                [imgWidth]="22"
                                                [imgHeight]="22"
                                                [imgClass]="'rounded'"
                                                [imgSrc]="'coinInfo/icon/receipt-edit-img.svg'"
                                                [imgStyle]="{ 'vertical-align': 'text-bottom', padding: '1px' }">
                                            </app-image>
                                        </span>
                                        {{ 'COIN.QUICK_LINKS.EXPLORER' | translate }}
                                    </div>
                                    <ul class="dropdown-menu">
                                        <li *ngFor="let explorer of quickLinks.explorer">
                                            <button
                                                class="dropdown-item d-flex justify-content-between"
                                                (click)="redirect(explorer)"
                                                aria-label="redirect to link">
                                                {{ explorer | truncate: 40 }}
                                                <picture>
                                                    <source [srcset]="CDN_URL + 'coinInfo/icon/' + 'export.svg'" />
                                                    <img
                                                        [src]="CDN_URL + 'coinInfo/icon/' + 'export.svg'"
                                                        alt=""
                                                        class="exit-top-right"
                                                        loading="lazy" />
                                                </picture>

                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <!-- Community dropdown -->
                            <div class="card quick-link-card" *ngIf="quickLinks.community.length > 0">
                                <div class="btn-group">
                                    <div
                                        type="button"
                                        class="dropdown-toggle w-100"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false">
                                        <span class="quick-links-icon me-2">
                                            <app-image
                                                [imgWidth]="18"
                                                [imgHeight]="18"
                                                [imgSrc]="'coinInfo/icon/people-img.svg'"
                                                [imgStyle]="{ 'vertical-align': 'sub', padding: '1px' }">
                                            </app-image>
                                        </span>
                                        {{ 'COIN.QUICK_LINKS.COMMUNITY' | translate }}
                                    </div>
                                    <ul class="dropdown-menu">
                                        <li *ngFor="let community of quickLinks.community">
                                            <button
                                                class="dropdown-item d-flex justify-content-between"
                                                (click)="redirect(community)"
                                                aria-label="redirect to link">
                                                {{ community | truncate: 40 }}
                                                <picture>
                                                    <source [srcset]="CDN_URL + 'coinInfo/icon/' + 'export.svg'" />
                                                    <img
                                                        [src]="CDN_URL + 'coinInfo/icon/' + 'export.svg'"
                                                        alt=""
                                                        class="exit-top-right"
                                                        loading="lazy" />
                                                </picture>

                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <!-- Source Code dropdown -->
                            <div class="card quick-link-card" *ngIf="quickLinks.sourceCode.length > 0">
                                <div class="btn-group">
                                    <div
                                        type="button"
                                        class="dropdown-toggle w-100"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false">
                                        <span class="quick-links-icon me-2">
                                            <app-image
                                                [imgWidth]="18"
                                                [imgHeight]="18"
                                                [imgSrc]="'coinInfo/icon/code-icon.svg'"
                                                [imgStyle]="{ 'vertical-align': 'sub', padding: '1px' }">
                                            </app-image>
                                        </span>
                                        {{ 'COIN.QUICK_LINKS.SOURCE_CODE' | translate }}
                                    </div>
                                    <ul class="dropdown-menu">
                                        <li *ngFor="let sourceCode of quickLinks.sourceCode">
                                            <button
                                                class="dropdown-item d-flex justify-content-between"
                                                (click)="redirect(sourceCode)"
                                                aria-label="redirect to link">
                                                {{ sourceCode | truncate: 40 }}
                                                <picture>
                                                    <source [srcset]="CDN_URL + 'coinInfo/icon/' + 'export.svg'" />
                                                    <img
                                                        [src]="CDN_URL + 'coinInfo/icon/' + 'export.svg'"
                                                        alt="export-icon"
                                                        class="exit-top-right"
                                                        loading="lazy" />
                                                </picture>

                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <!-- Documents dropdown -->
                            <div class="card quick-link-card" *ngIf="quickLinks.documents.length > 0">
                                <div class="btn-group">
                                    <div
                                        type="button"
                                        class="dropdown-toggle w-100"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false">
                                        <span class="quick-links-icon me-2">
                                            <app-image
                                                [imgWidth]="18"
                                                [imgHeight]="18"
                                                [imgSrc]="'coinInfo/icon/document-icon.svg'"
                                                [imgStyle]="{ 'vertical-align': 'sub', padding: '1px' }">
                                            </app-image>
                                        </span>
                                        {{ 'COIN.QUICK_LINKS.DOCUMENTS' | translate }}
                                    </div>
                                    <ul class="dropdown-menu">
                                        <li *ngFor="let document of quickLinks.documents">
                                            <button
                                                class="dropdown-item d-flex justify-content-between"
                                                (click)="redirect(document)"
                                                aria-label="redirect-to-link">
                                                {{ document | truncate: 40 }}
                                                <picture>
                                                    <source [srcset]="CDN_URL + 'coinInfo/icon/' + 'export.svg'" />
                                                    <img
                                                        [src]="CDN_URL + 'coinInfo/icon/' + 'export.svg'"
                                                        alt="export-icon"
                                                        class="exit-top-right"
                                                        loading="lazy" />
                                                </picture>

                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <!-- Tags -->
                            <div class="card-inner d-flex align-items-end p-0" style="background: transparent">
                                <div class="tags mt-2 mb-3">
                                    <p>{{ 'COIN.QUICK_LINKS.TAGS' | translate }} :</p>
                                    <ng-container *ngIf="quickLinks.tags.length > 0; else noTags">
                                        <a class="mb-2 mx-1" *ngFor="let tag of quickLinks.tags.slice(0, 4)">
                                            {{ tag | titlecase }}
                                        </a>
                                        <a class="mb-2" (click)="openTagsPopup()">
                                            {{ 'GENERAL.VIEW_ALL' | translate }}
                                        </a>
                                    </ng-container>
                                    <ng-template #noTags>
                                        <a class="mb-2 mx-1">
                                            {{ 'COIN.QUICK_LINKS.NO_TAGS_AVAILABLE' | translate }}
                                        </a>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #tagsPopupElement let-modal>
                <div class="modal-header">
                    <h5>
                        {{ coinDetail.coin_name | titlecase }}
                        {{ 'COIN.QUICK_LINKS.TAGS' | translate }}
                    </h5>
                    <button type="button" class="btn-close" aria-label="close" (click)="modal.close('closed')">
                        <em class="flaticon-close"></em>
                    </button>
                </div>
                <!-- Modal body -->
                <div class="modal-body px-0">
                    <div class="tags-popup mt-2 mb-3">
                        <a *ngFor="let tag of quickLinks.tags" class="mb-2">
                            {{ tag | titlecase }}
                        </a>
                    </div>
                </div>
            </ng-template>
            <div class="col-md-8 quick-link-section">
                <app-coin-chart
                    *ngIf="isBrowser"
                    [coinName]="coinDetail.coin_name"
                    [coinSymbol]="coinDetail.coin_symbol"
                    [fixedPrecision]="coinDetail.fixedPrecision">
                </app-coin-chart>
            </div>
        </div>

        <!-- ITB Widget: Token Summary -->
        <section id="summary" #sectionElement>
            <div class="row quick-link-section" *ngIf="sectionVisibilityMap.summary.showContent">
                <div id="widget-container">
                    <div class="itb-charts-group">
                        <h2 class="heading-three">
                            <span>{{ 'COIN.ACCORDIONS.TOKEN' | translate }}</span>
                            {{ 'COIN.HEADER.SUMMARY' | translate }}
                        </h2>
                        <div class="itb-token-summary itb-token-summary-without-title">
                            <div
                                data-target="itb-widget"
                                data-type="quick-view-v2"
                                data-options='{"highcharts": {"colors": ["#8b37f7"]}}'></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Token Banner -->
            <app-token-banner class="d-inline-block mt-0 mt-md-4 w-100"></app-token-banner>

        <div class="accordion bg-transparent coininfo-accordion">
            <!-- ITB Widget: Financial Data -->
            <section id="finance" #sectionElement>
                <div id="widget-container" *ngIf="sectionVisibilityMap.finance.showContent">
                    <div class="accordion-item border-0 bg-transparent finance-section">
                        <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                            <button
                                id="finance-accordion-header-btn"
                                class="accordion-button bg-transparent finance-btn"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#finance-accordion-content"
                                aria-expanded="true"
                                aria-label="financial data"
                                aria-controls="finance-accordion-content">
                                <h2 class="heading-three">
                                    <span> {{ 'COIN.ACCORDIONS.FINANCIAL' | translate }}</span>
                                    {{ 'GENERAL.DATA' | translate }}
                                </h2>
                            </button>
                        </h2>
                        <div
                            id="finance-accordion-content"
                            class="accordion-collapse collapse show"
                            aria-labelledby="panelsStayOpen-headingTwo">
                            <div class="accordion-body finance-body">
                                <div class="itb-charts-group">
                                    <div class="itb-charts-container grid">
                                        <div
                                            class="in-and-out-of-the-money"
                                            data-target="itb-widget"
                                            data-type="in-and-out-of-the-money"></div>
                                        <div
                                            data-target="itb-widget"
                                            data-type="break-even-price"
                                            class="itb-finance"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- ITB Widget: Network Data -->
            <section id="network" #sectionElement>
                <div id="widget-container" *ngIf="sectionVisibilityMap.network.showContent">
                    <div class="accordion-item border-0 bg-transparent finance-section">
                        <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                            <button
                                id="network-accordion-header-btn"
                                class="accordion-button bg-transparent finance-btn"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#network-accordion-content"
                                aria-expanded="true"
                                aria-label="network data"
                                aria-controls="network-accordion-content">
                                <h2 class="heading-three">
                                    <span>{{ 'COIN.ACCORDIONS.NETWORK' | translate }}</span>
                                    {{ 'GENERAL.DATA' | translate }}
                                </h2>
                            </button>
                        </h2>
                        <div
                            id="network-accordion-content"
                            class="accordion-collapse collapse show"
                            aria-labelledby="panelsStayOpen-headingThree">
                            <div class="accordion-body finance-body">
                                <div class="itb-charts-group">
                                    <div class="itb-charts-container grid network-grid">
                                        <div
                                            class="network-total-addresses pe-lg-1 pe-md-1"
                                            data-target="itb-widget"
                                            data-type="total-addresses"
                                            data-options='{"colors": {"highlights": { "average" : "#8b37f7"}},"highcharts": { "chart": {"height": 240}, "colors": ["#8b37f7", "#b94adc", "#ffbb4d"]}}'></div>
                                        <div
                                            class="network-total-daily-active-addresses ps-lg-1 ps-md-1"
                                            data-target="itb-widget"
                                            data-type="daily-active-addresses"
                                            data-options='{"colors": { "series": ["#8b37f7", "#b94adc", "#ffbb4d"]},"highcharts": { "chart": {"height": 240}, "colors": ["#8b37f7", "#b94adc", "#ffbb4d"]}}'></div>
                                        <div
                                            class="network-total-transactions-volume mt-2 pe-md-1"
                                            data-target="itb-widget"
                                            data-type="transactions-volume"
                                            data-options='{"colors": {"highlights": { "average" : "#8b37f7"}}, "highcharts": { "chart": {"height": 240}, "colors": ["#8b37f7", "#b94adc", "#ffbb4d"]}}'></div>
                                        <div
                                            class="network-total-number-of-transactions mt-2 ps-lg-1 ps-md-1"
                                            data-target="itb-widget"
                                            data-type="number-of-transactions"
                                            data-options='{"colors": {"highlights": { "average" : "#8b37f7"}}, "highcharts": { "chart": {"height": 240}, "colors": ["#8b37f7", "#b94adc", "#ffbb4d"]}}'></div>
                                        <div
                                            class="network-total-average-time-token-is-held mt-2 pe-md-1"
                                            data-target="itb-widget"
                                            data-type="average-time-token-is-held"
                                            data-options='{"colors": { "series": ["#8b37f7", "#b94adc"]}, "highcharts": { "chart": {"height": 260,  "type": "solidgauge","styledMode": false}}}'></div>
                                        <div
                                            class="network-total-concentration"
                                            class="concentration mt-2 ps-lg-1 ps-md-1">
                                            <div
                                                data-target="itb-widget"
                                                data-type="concentration"
                                                data-options='{"colors": { "series": ["#b94adc", "#8b37f7", "#ffbb4d"]}, "highcharts": { "chart": {"height": 240, "styledMode": false, "type": "pie", "spacing": [10, 0, 0, 0]}}}'></div>
                                        </div>
                                        <div
                                            class="network-total-east-vs-west mt-2"
                                            data-target="itb-widget"
                                            data-type="east-vs-west"
                                            data-options='{"colors": { "series": ["#8b37f7", "#b94adc"], "highlights": {"base": "gray"}}, "highcharts": { "chart": {"height": 240}, "colors": ["#8b37f7", "#b94adc", "#ffbb4d"]}}'></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- ITB Widget: Ownership Data -->
            <section id="ownership" #sectionElement>
                <div id="widget-container" *ngIf="sectionVisibilityMap.ownership.showContent">
                    <div class="accordion-item border-0 bg-transparent mt-3">
                        <h2 class="accordion-header" id="panelsStayOpen-headingFour">
                            <button
                                type="button"
                                id="ownership-accordion-header-btn"
                                class="accordion-button bg-transparent px-0"
                                data-bs-toggle="collapse"
                                data-bs-target="#ownership-accordion-content"
                                aria-expanded="true"
                                aria-label="ownership data"
                                aria-controls="ownership-accordion-content">
                                <h2 class="heading-three py-0 my-0">
                                    <span>{{ 'COIN.ACCORDIONS.OWNERSHIP' | translate }}</span>
                                    {{ 'GENERAL.DATA' | translate }}
                                </h2>
                            </button>
                        </h2>
                        <div
                            id="ownership-accordion-content"
                            class="accordion-collapse collapse show"
                            aria-labelledby="panelsStayOpen-headingFour">
                            <div class="accordion-body p-0">
                                <div class="itb-charts-group">
                                    <div class="itb-charts-container grid ownership-grid">
                                        <div
                                            class="ownership-addresses-by-time-held pe-lg-1 pe-md-1"
                                            data-target="itb-widget"
                                            data-type="addresses-by-time-held"
                                            data-options='{"colors": { "series": ["#8b37f7", "#b94adc", "#ffbb4d"]}, "highcharts": { "chart": {"height": 240, "styledMode": false}}}'></div>
                                        <div
                                            class="ownership-balance-by-time-held ps-lg-1 ps-md-1"
                                            data-target="itb-widget"
                                            data-type="balance-by-time-held"
                                            data-options='{"colors": { "series": ["#8b37f7", "#b94adc", "#ffbb4d"]}, "highcharts": { "chart": {"height": 240, "styledMode": false}}}'></div>
                                        <div
                                            class="ownership-holdings-distribution-matrix mt-2"
                                            data-target="itb-widget"
                                            data-type="holdings-distribution-matrix"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- ITB Widget: Social Data -->
            <section id="social" #sectionElement>
                <div id="widget-container" *ngIf="sectionVisibilityMap.social.showContent">
                    <div class="accordion-item border-0 bg-transparent mt-3">
                        <h2 class="accordion-header" id="panelsStayOpen-headingSocial">
                            <button
                                type="button"
                                id="social-accordion-header-btn"
                                class="accordion-button bg-transparent px-0"
                                data-bs-toggle="collapse"
                                data-bs-target="#social-accordion-content"
                                aria-expanded="true"
                                aria-label="social data"
                                aria-controls="social-accordion-content">
                                <h2 class="heading-three py-0 my-0">
                                    <span> {{ 'COIN.ACCORDIONS.SOCIAL' | translate }}</span>
                                    {{ 'GENERAL.DATA' | translate }}
                                </h2>
                            </button>
                        </h2>
                        <div
                            id="social-accordion-content"
                            class="accordion-collapse collapse show"
                            aria-labelledby="panelsStayOpen-headingSocial">
                            <div class="accordion-body p-0">
                                <div class="itb-charts-group">
                                    <div class="itb-charts-container grid column-2">
                                        <div
                                            class="social-sub-widget pe-lg-1 pe-md-1"
                                            data-target="itb-widget"
                                            data-type="telegram-sentiment"
                                            data-options='{ "colors": { "series": ["#8b37f7", "#b94adc", "#ffbb4d"]}, "highcharts": { "chart": {"height": 260}}}'></div>
                                        <div
                                            class="social-sub-widget ps-lg-1 ps-md-1"
                                            data-target="itb-widget"
                                            data-type="twitter-sentiment-v2"
                                            data-options='{ "colors": { "series": ["#8b37f7", "#b94adc", "#ffbb4d"]}, "highcharts": { "chart": {"height": 260}}}'></div>
                                        <div
                                            class="social-sub-widget mt-2 pe-lg-1 pe-md-1"
                                            data-target="itb-widget"
                                            data-type="github-v2"
                                            data-options='{ "colors": { "series": ["#8b37f7", "#b94adc", "#ffbb4d", "#E56651", "#4A90E2", "#678b9b", "#ffd647", "#87f1cb", "#aaae27", "#a82a2a", "#27ae60"]}, "highcharts": { "chart": {"height": 260}}}'></div>
                                        <div
                                            class="social-sub-widget mt-2 ps-lg-1 ps-md-1"
                                            data-target="itb-widget"
                                            data-type="search-trends"
                                            data-options='{ "colors": { "series": ["#8b37f7"]}, "highcharts": { "chart": {"height": 260}}}'></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Market Data -->
            <section id="markets" #sectionElement>
                <div
                    class="accordion-item tab-pane border-0 bg-transparent mt-3"
                    #table
                    *ngIf="sectionVisibilityMap.markets.showContent">
                    <h2 class="accordion-header" id="panelsStayOpen-headingFive">
                        <button
                            id="market-accordion-header-btn"
                            type="button"
                            class="accordion-button bg-transparent px-0 pb-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#market-accordion-content"
                            aria-expanded="true"
                            aria-label="market data"
                            aria-controls="market-accordion-content">
                            <h2 class="heading-three py-0 my-0">
                                <span> {{ 'GENERAL.MARKETS' | translate }} </span>
                            </h2>
                        </button>
                    </h2>
                    <div
                        id="market-accordion-content"
                        class="accordion-collapse collapse show"
                        aria-labelledby="panelsStayOpen-headingFive">
                        <div class="accordion-body p-0">
                            <div class="card border-0 white-bg table-responsive table-corner table-bold p-3 mb-0 mt-3">
                                <div class="searchBox">
                                    <div class="input-group flex-nowrap justify-content-end">
                                        <div class="form-outline w-100">
                                            <input
                                                type="search"
                                                class="form-control"
                                                autocomplete="off"
                                                [formControl]="searchControl"
                                                placeholder="{{ 'GENERAL.SEARCH_COIN' | translate }}"
                                                #searchBox />
                                        </div>
                                        <button type="button" class="btn-search" aria-label="search">
                                            <em class="flaticon-magnifier search-icon"></em>
                                        </button>
                                    </div>
                                </div>

                                <div class="table-responsive">
                                    <table
                                        class="table table-hover table-striped mb-2"
                                        style="min-width: max-content"
                                        aria-describedby="">
                                        <thead>
                                            <tr class="table-headline">
                                                <!-- Pair -->
                                                <th
                                                    scope="col"
                                                    class="ps-0"
                                                    sortable="baseCoinCode"
                                                    (sort)="onSort($event)">
                                                    <div class="d-flex align-items-center pointer user-select-none">
                                                        {{ 'COIN.MARKET.PAIR' | translate }}
                                                        <ng-container
                                                            [ngTemplateOutlet]="sortIconTemplate"></ng-container>
                                                    </div>
                                                </th>

                                                <!-- Last Price -->
                                                <th scope="col" sortable="last_price" (sort)="onSort($event)">
                                                    <div class="d-flex align-items-center pointer user-select-none">
                                                        {{ 'COIN.OVERVIEW.PRICE_TILE.LAST_PRICE' | translate }}
                                                        <ng-container
                                                            [ngTemplateOutlet]="sortIconTemplate"></ng-container>
                                                    </div>
                                                </th>

                                                <!-- 24H Change -->
                                                <th scope="col" sortable="price_change_percent" (sort)="onSort($event)">
                                                    <div class="d-flex align-items-center pointer user-select-none">
                                                        24H %
                                                        <ng-container
                                                            [ngTemplateOutlet]="sortIconTemplate"></ng-container>
                                                    </div>
                                                </th>

                                                <!-- 24H High / 24H Low -->
                                                <th scope="col" sortable="high_price" (sort)="onSort($event)">
                                                    <div class="d-flex align-items-center pointer user-select-none">
                                                        <div class="d-inline-flex">
                                                            <span>
                                                                {{ 'COIN.OVERVIEW.PRICE_TILE.24H_HIGH' | translate }}
                                                            </span>
                                                            <span class="mx-1">/</span>
                                                            <span>
                                                                {{ 'COIN.OVERVIEW.PRICE_TILE.24H_LOW' | translate }}
                                                            </span>
                                                        </div>
                                                        <ng-container
                                                            [ngTemplateOutlet]="sortIconTemplate"></ng-container>
                                                    </div>
                                                </th>

                                                <!-- 24H Volume -->
                                                <th scope="col" sortable="quote_volume" (sort)="onSort($event)">
                                                    <div class="d-flex align-items-center pointer user-select-none">
                                                        {{ 'COIN.OVERVIEW.VOLUME_TILE.24H_VOLUME' | translate }}
                                                        <ng-container [ngTemplateOutlet]="sortIconTemplate">
                                                        </ng-container>
                                                    </div>
                                                </th>

                                                <!-- Market Cap -->
                                                <th scope="col" sortable="marketCap" (sort)="onSort($event)">
                                                    <div class="d-flex align-items-center pointer user-select-none">
                                                        {{ 'GENERAL.MARKET_CAP' | translate }}
                                                        <ng-container [ngTemplateOutlet]="sortIconTemplate">
                                                        </ng-container>
                                                    </div>
                                                </th>

                                                <th scope="col">
                                                    {{ 'GENERAL.ACTION' | translate }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                *ngFor="
                                                    let item of marketPairs
                                                        | slice: (page - 1) * pageSize : page * pageSize
                                                ">
                                                <!-- Code Code & Image -->
                                                <td>
                                                    <div class="text-medium nowrap">
                                                        <span class="multi-coin">
                                                            <picture>
                                                                <source [srcset]="CDN_URL + item.baseCoinIcon" />
                                                                <img
                                                                    [alt]="item.baseCoinCode"
                                                                    [src]="CDN_URL + item.baseCoinIcon"
                                                                    loading="lazy" />
                                                            </picture>
                                                            <picture>
                                                                <source [srcset]="CDN_URL + item.quoteCoinIcon" />
                                                                <img
                                                                    [alt]="item.quoteCoinCode"
                                                                    [src]="CDN_URL + item.quoteCoinIcon"
                                                                    loading="lazy" />
                                                            </picture>

                                                        </span>
                                                        <span>
                                                            <strong>{{ item.baseCoinCode }}</strong
                                                            >/{{ item.quoteCoinCode }}
                                                        </span>
                                                    </div>
                                                </td>

                                                <!-- Last Price -->
                                                <td class="nowrap">
                                                    <span>
                                                        <strong>
                                                            {{
                                                                item.last_price
                                                                    | removeExponent
                                                                    | number: '1.0-' + item.quote_coin_precision
                                                            }}
                                                        </strong>
                                                    </span>
                                                    <span>/</span>
                                                    {{
                                                        item.priceInFiat
                                                            | fiatValue: usdExchangeRate
                                                            | currency
                                                                : currencySymbol
                                                                : 'symbol'
                                                                : '1.1-' + item.quote_coin_precision
                                                    }}
                                                </td>

                                                <!-- 24h Change -->
                                                <td>
                                                    <span
                                                        [ngClass]="
                                                            item.price_change_percent >= 0
                                                                ? 'text-success'
                                                                : 'text-danger'
                                                        ">
                                                        <em
                                                            [ngClass]="
                                                                item.price_change_percent >= 0
                                                                    ? 'flaticon-two-arrows-pointing-up'
                                                                    : 'flaticon-two-down-arrows'
                                                            "
                                                            style="font-size: 10px">
                                                        </em>
                                                        <span class="mx-1">
                                                            <span>
                                                                {{
                                                                    item.price_change_percent
                                                                        | absValue
                                                                        | number: '1.2-2'
                                                                }}%
                                                            </span>
                                                        </span>
                                                    </span>
                                                </td>

                                                <!-- 24H High / 24H Low -->
                                                <td>
                                                    <span class="text-success">
                                                        {{
                                                            item.high_price
                                                                | removeExponent
                                                                | number: '1.0-' + item.quote_coin_precision
                                                        }}
                                                    </span>
                                                    <span>/</span>
                                                    <span class="text-danger">
                                                        {{
                                                            item.low_price
                                                                | removeExponent
                                                                | number: '1.0-' + item.quote_coin_precision
                                                        }}
                                                    </span>
                                                </td>

                                                <!-- 24H Volume -->
                                                <td class="p-0-1">
                                                    {{ item.quote_volume | shortNumber }}
                                                </td>

                                                <!-- Market Cap -->
                                                <td>
                                                    {{
                                                        item.marketCap
                                                            | fiatValue: usdExchangeRate
                                                            | placeValue: 'million'
                                                            | currency: currencySymbol : 'symbol' : '1.1-1'
                                                    }}M
                                                </td>

                                                <td>
                                                    <button
                                                        class="btn-outline btn-outline-xs"
                                                        aria-label="trade"
                                                        (click)="
                                                            redirectToTrade(item.baseCoinCode, item.quoteCoinCode)
                                                        ">
                                                        {{ 'HEADER.NAV_MENU.TRADE' | translate }}
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody *ngIf="!marketPairs.length">
                                            <tr>
                                                <td colspan="7">
                                                    {{ 'GENERAL.NO_DATA_AVAILABLE' | translate }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <!-- Pagination: Mobile View -->
                            <div class="d-xs-block d-sm-block d-md-none d-lg-none mt-2 text-md-end">
                                <ngb-pagination
                                    *ngIf="marketPairs.length > pageSize"
                                    [(page)]="page"
                                    [maxSize]="5"
                                    [pageSize]="pageSize"
                                    [ellipses]="false"
                                    [rotate]="true"
                                    [boundaryLinks]="true"
                                    [directionLinks]="false"
                                    [collectionSize]="marketPairs.length"
                                    class="ngb-pagination"
                                    (pageChange)="onPageChange(table)">
                                </ngb-pagination>
                            </div>
                            <!-- Pagination: Desktop View -->
                            <div class="d-none d-md-block mt-2 text-md-end">
                                <ngb-pagination
                                    *ngIf="marketPairs.length > pageSize"
                                    [maxSize]="5"
                                    [(page)]="page"
                                    [rotate]="true"
                                    [ellipses]="true"
                                    [pageSize]="pageSize"
                                    [collectionSize]="marketPairs.length"
                                    class="ngb-pagination"
                                    (pageChange)="onPageChange(table)">
                                    <ng-template ngbPaginationPrevious>
                                        <em class="flaticon-left-chevron-1"></em>
                                    </ng-template>
                                    <ng-template ngbPaginationNext>
                                        <em class="flaticon-right-chevron"></em>
                                    </ng-template>
                                </ngb-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <ng-template #sortIconTemplate>
                <span class="position-relative sorting-icon">
                    <em class="flaticon-sort-up sort-up"></em>
                    <em class="flaticon-sort-down sort-up"></em>
                </span>
            </ng-template>
            <!-- Token Banner -->
            <!-- <app-token-banner class="d-inline-block mt-0 mt-md-1 w-100"></app-token-banner> -->
            <!-- News Section -->
            <div class="accordion-item tab-pane border-0 bg-transparent finance-section">
                <section id="news" #sectionElement>
                    <div class="container" class="finance-body" *ngIf="sectionVisibilityMap.news.showContent">
                        <div>
                            <h3 class="itb-finance subheading">
                                <span>{{ 'NEWS.LATEST' | translate }}</span>
                                {{ 'GENERAL.NEWS' | translate }}
                            </h3>
                            <p class="font14 section-subtitle">{{ 'NEWS.SUBTEXT' | translate }}</p>
                            <app-crypto-news
                                [newsPayload]="newsPayload"
                                (showAndHideNewsEvent)="toggleNewsVisibility($event)">
                            </app-crypto-news>
                             <ng-container *ngIf="newsData?.docsCount < newsData?.totalDocs">
                                <div class="col-12 new-section mt-4 mb-3 text-center">
                                    <button
                                        type="button"
                                        class="btn-outline btn-outline-lg"
                                        aria-label="see more"
                                        [routerLink]="['/news/coin', coinDetail.coin_symbol.toUpperCase()]">
                                        {{ 'NEWS.SEE_MORE' | translate }}
                                    </button>
                                </div>
                             </ng-container>
                        </div>
                    </div>
                </section>
            </div>

            <!-- Trending Coins -->
            <app-trending></app-trending>
        </div>
    </div>
</div>

<ng-template #dropdownList let-data>
    <app-dropdown-list [list]="data.value" [dataType]="data.type" (clickEvent)="redirectToExchange(data.type, $event)">
        {{ 'GENERAL.NO_PAIR_FOUND' | translate }}
    </app-dropdown-list>
</ng-template>

<ng-template #dropdownSkeleton>
    <div class="mb-2 mb-md-0 mx-1" *ngIf="isWalletPairsLoading">
        <ngx-skeleton-loader
            appearance="line"
            animation="pulse"
            [theme]="{
                height: '26px',
                'margin-right': '75px',
                'margin-bottom': '0px',
                'border-radius': '8px',
                'background-color': skeletonBackground
            }">
        </ngx-skeleton-loader>
    </div>
</ng-template>
